export type EmailObsKind =
  | 'sent'
  | 'delivered'
  | 'delayed'
  | 'rejected'
  | 'opened'
  | 'clicked'
  | 'complained'
  | 'unsubscribed';

export type EmailObsState = 'success' | 'failed' | 'pending';

export type EmailObsPeriod = '7' | '30' | 'ciclo';

export type ObsChannel = 'email' | 'sms';

export interface EmailObsStep {
  at: string;
  label: string;
  detail: string;
}

export interface EmailObsEvent {
  id: string;
  at: string;
  companyId: string;
  companyName: string;
  campaignId: string;
  campaignName: string;
  recipientMasked: string;
  /** Ausente significa e-mail, para os eventos que já existiam. */
  channel?: ObsChannel;
  kind: EmailObsKind;
  state: EmailObsState;
  cause: string | null;
  subject: string;
  sequence: EmailObsStep[];
}

export interface EmailObsFilters {
  period: EmailObsPeriod;
  companyId: string;
  campaignId: string;
  state: EmailObsState | 'all';
  channel?: ObsChannel | 'all';
}

/** Hoje desta demonstração. Os filtros de período não seguem o relógio do computador. */
export const EMAIL_OBS_NOW = new Date('2026-10-20T15:00:00-03:00');

export const EMAIL_OBS_KIND_LABEL: Record<EmailObsKind, string> = {
  sent: 'Envio',
  delivered: 'Entrega',
  delayed: 'Atraso',
  rejected: 'Rejeição',
  opened: 'Abertura',
  clicked: 'Clique',
  complained: 'Reclamação',
  unsubscribed: 'Descadastro',
};

export const EMAIL_OBS_STATE_META: Record<EmailObsState, { label: string; variant: 'success' | 'destructive' | 'warning' }> = {
  success: { label: 'Sucesso', variant: 'success' },
  failed: { label: 'Falha', variant: 'destructive' },
  pending: { label: 'Pendente', variant: 'warning' },
};

function periodStart(period: EmailObsPeriod): Date {
  if (period === '7') return new Date('2026-10-13T00:00:00-03:00');
  if (period === '30') return new Date('2026-09-20T00:00:00-03:00');
  return new Date('2026-10-10T00:00:00-03:00');
}

export function filterEmailObsEvents(events: EmailObsEvent[], filters: EmailObsFilters): EmailObsEvent[] {
  const from = periodStart(filters.period);
  return events
    .filter((event) => {
      const at = new Date(event.at);
      if (Number.isNaN(at.getTime()) || at < from || at > EMAIL_OBS_NOW) return false;
      if (filters.companyId !== 'all' && event.companyId !== filters.companyId) return false;
      if (filters.campaignId !== 'all' && event.campaignId !== filters.campaignId) return false;
      if (filters.state !== 'all' && event.state !== filters.state) return false;
      if (filters.channel && filters.channel !== 'all' && (event.channel ?? 'email') !== filters.channel) return false;
      return true;
    })
    .slice()
    .sort((a, b) => b.at.localeCompare(a.at));
}
